import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=5f9b32f8&scoped=true"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b32f8",
  null
  
)

export default component.exports